import React from 'react'
import PropTypes from 'prop-types'
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  Typography,
  Box,
} from '@material-ui/core'
import PerfectScrollbar from 'react-perfect-scrollbar'

import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from 'components/Table'

import helpers from 'helpers'

const LogEmailDialog = ({ setOpen = () => {}, open = false, logs = [] }) => {
  const handleClose = () => setOpen(false)

  return (
    <Dialog open={open} onClose={handleClose} maxWidth fullWidth>
      <DialogTitle>
        <Typography variant="h4">Histórico de e-mails</Typography>
      </DialogTitle>
      <Divider />
      <DialogContent>
        {!logs ? (
          <Typography>Não existe nenhum histórico</Typography>
        ) : (
          <Box width="100%">
            <PerfectScrollbar>
              <Table size="medium" noWrap stickyHeader>
                <TableBody>
                  {logs?.map((log, index) => (
                    <TableRow key={index}>
                      <TableCell colSpan={3}>
                        <Table size="small" stickyHeader>
                          <TableHead>
                            <TableRow>
                              <TableCell width="10%">Enviado para</TableCell>
                              <TableCell width="10%">
                                Enviado com sucesso
                              </TableCell>
                              <TableCell width="10%">Data de envio</TableCell>
                              <TableCell width="70%">Nome do e-mail</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {log?.userEmails?.map((email, index) => (
                              <TableRow key={index}>
                                <TableCell>{email}</TableCell>
                                <TableCell>
                                  {log?.success ? 'Sim' : 'Não'}
                                </TableCell>
                                <TableCell>
                                  <Typography variant="body2">
                                    {helpers.formatters.date(
                                      log?.createdAt,
                                      'DD/MM/YYYY HH:mm:ss',
                                    )}
                                  </Typography>
                                </TableCell>
                                <TableCell>{log?.mailName}</TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </PerfectScrollbar>
          </Box>
        )}
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button type="button" variant="outlined" onClick={handleClose}>
          Voltar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

LogEmailDialog.propTypes = {
  setOpen: PropTypes.func,
  open: PropTypes.bool,
  logs: PropTypes.arrayOf(
    PropTypes.shape({
      userEmails: PropTypes.arrayOf(PropTypes.string),
      success: PropTypes.bool,
      createdAt: PropTypes.string,
      mailName: PropTypes.string,
    }),
  ),
}

export default LogEmailDialog
